import React from 'react'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import { BsFillPersonLinesFill } from "react-icons/bs";
function SocialLinks() {
    const links = [
        {
            id: 1,
            child: (
                <>
                LinkedIn <FaLinkedin size={30}/>
                </>
                
            ),
            href: 'https://www.linkedin.com/in/sneha-tomar-266b10312/',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                GitHub <FaGithub size={30}/>
                </>
                
            ),
            href: 'https://github.com/snehatomar1205',
            
        },
        {
            id: 3,
            child: (
                <>
                Mail<HiOutlineMail size={30}/>
                </>
                
            ),
            href: 'mailto:snehatomar8612@gmail.com',
            
        },
        {
            id: 4,
            child: (
                <>
                Resume <BsFillPersonLinesFill size={30}/>
                </>
                
            ),
            href: 'https://flowcv.com/resume/2sf861oaku8i',
            style: 'rounded-br-md',
            
        }
    ]
  return (
    <div className='hidden lg:flex flex-col  top-[35%] left-0 fixed' >
      <ul>

        {links.map(({id, child, href, style, download}) => (
            <li key={id} className={'flex justify-between items-center w-40 h-14 px-4 hover:ml-[-10px] ml-[-100px] bg-gray-500 duration-300 ' + '' + style}>
            <a href={href} className='flex justify-between items-center w-full text-white' target='_blank'>
                {child}
            </a>
        </li>
        ))}
      
      </ul>
    </div>
  )
}

export default SocialLinks
